import { render, staticRenderFns } from "./MouserConfigurator.vue?vue&type=template&id=64443986&scoped=true&lang=pug&"
import script from "./MouserConfigurator.vue?vue&type=script&lang=js&"
export * from "./MouserConfigurator.vue?vue&type=script&lang=js&"
import style0 from "./MouserConfigurator.vue?vue&type=style&index=0&id=64443986&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64443986",
  null
  
)

export default component.exports